<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { Image } from '@sanity/types';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
    anchorId?: string;
    activeCampaign: boolean,
    initialPreTitle: string,
    initialTitle: string,
    initialText: string,
    confirmationPreTitle: string,
    confirmationTitle: string,
    confirmationText: string,
    ctaText: string,
    socialsTitle: string,
    statisticChoice: string,
    shareTitle: string,
    shareDescription: string,
    backgroundImage: Image,
    confirmationImage:Image,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  activeCampaign: props.block?.activeCampaign,
  initialPreTitle: props.block?.initialPreTitle,
  initialTitle: props.block?.initialTitle,
  initialText: props.block?.initialText,
  confirmationPreTitle: props.block?.confirmationPreTitle,
  confirmationTitle: props.block?.confirmationTitle,
  confirmationText: props.block?.confirmationText,
  ctaText: props.block?.ctaText,
  socialsTitle: props.block?.socialsTitle,
  shareTitle: props.block?.shareTitle,
  shareDescription: props.block?.shareDescription,
  backgroundImage: props.block?.backgroundImage,
  confirmationImage: props.block?.confirmationImage,
  statisticChoice: props.block?.statisticChoice,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data" />
</template>
